import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
	RecoverQuestion,
	TwoFaRecoverData,
	TwoFaRecoverDataToSend,
	UserLoginPayload
} from '@models/two-fa.models';
import { TwoFaAuthenticationDataService } from '@services/user/two-fa-authentication.data.service';
import { FormControl, FormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { MessageService } from '@services/helpers/message-service/message.service';
import { AccessTokens } from '@models/models';
import { AccountDataServiceProvider } from '@services/user/account.data.service';
import { TwoFaAuthenticationService } from '@services/user/two-fa-authentication.service';

import { AuthTokensService } from '../../../../auth-tokens.service';

@Component({
	selector: 'two-fa-setup',
	template: require('./two-fa-reset-modal.html'),
	styles: [require('./two-fa-reset-modal.scss')]
})
export class TwoFaResetModalComponent implements OnInit, OnDestroy {
	@Input() recoverUser2FA: TwoFaRecoverData;
	@Input() userPayload: UserLoginPayload;

	buttonDisable: boolean;
	recoverForm: FormGroup;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private activeModal: NgbActiveModal,
		private twoFaAuthenticationDataService: TwoFaAuthenticationDataService,
		private twoFaAuthenticationService: TwoFaAuthenticationService,
		private messageService: MessageService,
		private accountDataService: AccountDataServiceProvider,
		private authTokenService: AuthTokensService
	) {}

	ngOnInit(): void {
		this.setupReactiveForm();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	resetAuthentication(): void {
		const dataToSend = this.prepareDataToSend();
		if (
			this.twoFaAuthenticationService.isTwoFaResetDataValid(
				dataToSend.questions
			)
		) {
			const { url, method } = this.recoverUser2FA.actions.RECOVER_2FA;
			this.buttonDisable = true;

			this.twoFaAuthenticationDataService
				.reset2FaAuthentication(url, method, dataToSend)
				.pipe(takeUntil(this.unsubscribe))
				.subscribe(
					(): void => this.performLogin(),
					({ error }): void => {
						this.buttonDisable = false;
						const { errorTitle, errorMessage } = error;
						this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					}
				);
		}
	}

	moveToLoginModal(): void {
		if (!this.buttonDisable) {
			this.activeModal.close('LAUNCH_LOGIN');
		}
	}

	onDismiss(): void {
		if (!this.buttonDisable) {
			this.activeModal.dismiss();
		}
	}

	private setupReactiveForm(): void {
		const controls = {};
		this.recoverUser2FA.secretQuestions.forEach(
			(question: RecoverQuestion): void => {
				controls[question.id] = new FormControl();
			}
		);
		this.recoverForm = new FormGroup(controls);
	}

	private prepareDataToSend(): TwoFaRecoverDataToSend {
		const data = [];
		Object.keys(this.recoverForm.value).forEach((questionId: string): void => {
			data.push({ questionId, answer: this.recoverForm.value[questionId] });
		});

		return { questions: data };
	}

	private performLogin(): void {
		this.accountDataService
			.authenticateWithTwoFa(
				this.userPayload.userData,
				this.userPayload.authorizationKey
			)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): boolean => (this.buttonDisable = false))
			)
			.subscribe(
				(data: AccessTokens): void => {
					this.messageService.showToaster('s_5', 'twoFa');
					this.authTokenService.successGetRefreshedToken(data);
					this.activeModal.close('SUCCESS_LOGIN');
				},
				({ error }): void => {
					const { errorTitle, errorMessage } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal.ts